<template>
  <div :class="cols">
    <label v-if="showLabel" class="block text-sm font-medium text-gray-700" :for="id">{{label}}</label>
    <div class="mt-1 relative">
      <input type="text"
             v-model="modelValue"
             :id="id"
             :name="id"
             class="shadow-sm focus:ring-blue-700 focus:border-blue-700 placeholder-gray-400 block w-full sm:text-sm border-gray-400 rounded-md"
             :class="{'pointer-events-none bg-gray-200 text-gray-400' : isDisabled}"
             aria-invalid="false"
             :inputmode="inputMode"
             ref="myInput"
             :placeholder="placeholder"
      >
      <div v-if="hasEuroSign" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
        €
      </div>
    </div>
      <p v-if="errors[id]" class="mt-2 text-sm text-red-600 error-message">{{ errors[id] }}</p>
      <p v-else-if="warnings[id]" class="mt-2 text-sm text-yellow-600">{{ warnings[id] }}</p>
  </div>
</template>

<script setup>
import {watch, computed} from "vue";
import {useTenantStore} from "../stores/tenant";

const props = defineProps({
  cols: {
    type: String,
    default: "sm:col-span-3"
  },
  label: {
    type: String,
  },
  id: {
    type: String,
  },
  placeholder: {
    type: String,
  },
  dataName: {
    type: String,
  },
  hasEuroSign: {
    type: Boolean,
    default: false,
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  inputMode: {
    type: String,
    default: 'text',
  }
});

const tenant = useTenantStore();

// computed Property to sync parent data with input value
const modelValue = computed({
  get: () => tenant.formValues[props.id] || '',
  set: (value) => tenant.setFormValue(props.id, value)
});

const errors = computed(() => tenant.errors);
const warnings = computed(() => tenant.warnings);

watch(modelValue, async (newValue) => {
  await tenant.validateField(props.id, newValue);
});

</script>
